export enum CustomizationBackground {
    LOGIN = "login",
    WAITING = "waiting",
    VOTE = "vote",
}

export interface PageBackgroundProps {
    customizationBackground: CustomizationBackground;
}
